import React from 'react';
import { faFolderOpen } from '@fortawesome/free-regular-svg-icons';
import {
  faCalendarAlt,
  faClock,
  faEdit,
  faFolder,
  faGavel,
  faGlobeAmericas,
  faIdBadge,
  faLocationArrow,
  faPaperPlane,
  faSignature,
  faTrash,
  faUser,
  faWeight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import store from 'app/store';

import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import _ from 'lodash';
import moment from 'moment-timezone';

import { Button, Card, Col, Row } from 'react-bootstrap';
import enums from 'util/enums';
import filters from 'util/filters';
import userHelper from './userHelper';

const getSignatureViewCards = (title, imageData) => {
  return imageData ? (
    <Col lg={4} className="mb-3">
      <Card className="h-md-100">
        <Card.Header className="pb-0">
          <Flex
            justifyContent="between"
            alignContent="center"
            alignItems="center"
          >
            <Flex
              justifyContent="center"
              alignContent="center"
              alignItems="center"
            >
              <FontAwesomeIcon icon={faIdBadge} size="lg" className="me-3" />
              <h5 className="mb-0 mb-1">{title}</h5>
            </Flex>
          </Flex>
          <hr className="my-0" />
        </Card.Header>

        <Card.Body as={Flex} justifyContent="between" className="pt-1">
          <div className="fs--1">
            <img
              style={{ maxHeight: 150, maxWidth: '100%' }}
              src={'data:image/png;base64,' + imageData}
            />
          </div>
        </Card.Body>
      </Card>
    </Col>
  ) : (
    <></>
  );
};

const getSignatureViewImage = (
  imageData,
  maxWidth,
  maxHeight,
  className = ''
) => {
  return imageData ? (
    <img
      className={className}
      style={{
        maxHeight: maxHeight ? maxHeight : 'auto',
        maxWidth: maxWidth ? maxWidth : 'auto',
        objectFit: 'contain'
      }}
      src={'data:image/png;base64,' + imageData}
    />
  ) : (
    <></>
  );
};

const getFingerprintViewImage = (
  imageData,
  maxWidth,
  maxHeight,
  className = ''
) => {
  return imageData ? (
    <img
      className={className}
      style={{
        maxHeight: maxHeight ? maxHeight : 'auto',
        maxWidth: maxWidth ? maxWidth : 'auto'
      }}
      src={'data:image/png;base64,' + imageData}
    />
  ) : (
    <></>
  );
};

const getWitnessAddressViewCards = (address, col = 4) => {
  return address &&
    (address?.address_1 ||
      address?.address_2 ||
      address?.city ||
      address?.state ||
      address?.postal_code) ? (
    <Col lg={col} className="mb-3">
      <Card className="h-md-100">
        <Card.Header className="pb-0">
          <Flex
            justifyContent="between"
            alignContent="center"
            alignItems="center"
          >
            <Flex
              justifyContent="center"
              alignContent="center"
              alignItems="center"
            >
              <FontAwesomeIcon icon={faIdBadge} size="lg" className="me-3" />
              <h5 className="mb-0 mb-1">Witness Address</h5>
            </Flex>
          </Flex>
          <hr className="my-0" />
        </Card.Header>

        <Card.Body as={Flex} justifyContent="between" className="pt-1">
          <div className="fs--1">
            {address?.address_1 && (
              <p className="mb-1">
                <span className="fw-semi-bold">Address line 1:</span>{' '}
                {address.address_1}
              </p>
            )}
            {address?.address_2 && (
              <p className="mb-1">
                <span className="fw-semi-bold">Address line 2:</span>{' '}
                {address.address_2}
              </p>
            )}
            {address?.city && (
              <p className="mb-1">
                <span className="fw-semi-bold">City: </span> {address.city}
              </p>
            )}
            {address?.state && (
              <p className="mb-1">
                <span className="fw-semi-bold">State:</span> {address.state}
              </p>
            )}
            {(address?.zip || address?.postal_code) && (
              <p className="mb-1">
                <span className="fw-semi-bold">Zip:</span>{' '}
                {address.zip || address.postal_code}
              </p>
            )}
            {address?.notes && (
              <p className="mb-1">
                <span className="fw-semi-bold">Notes:</span>{' '}
                <i className="fs--1">{address.notes}</i>
              </p>
            )}
          </div>
          <div></div>
        </Card.Body>
      </Card>
    </Col>
  ) : (
    <></>
  );

  // <div>
  //   <Button variant='outline-primary' onClick={() => openLocalIdentityViewModel(`${formTitle}'s Identity`, identification)}><FontAwesomeIcon icon={faIdBadge} /> View Identification <SoftBadge>{identification.length}</SoftBadge></Button>
  // </div> : <></>;
};

const getWitnessViewCard = (witness, witnessIdentification) => {
  return (
    <Row>
      {witness?.location &&
        (witness?.location?.address_1 ||
          witness?.location?.address_2 ||
          witness?.location?.city ||
          witness?.location?.state ||
          witness?.location?.zip) && (
          <Col sm={12} md={4}>
            <Card className="h-md-100">
              <Card.Header>
                {filters.formatNameObj(witness.witness_name)}
              </Card.Header>

              {!!witness.location && (
                <Card.Body>
                  <p className="mb-1">
                    {witness.location.address_1} {witness.location.address_2}
                  </p>
                  <p className="mb-1">
                    {witness.location.city}, {witness.location.state},{' '}
                    {witness.location.zip}
                  </p>
                </Card.Body>
              )}
            </Card>
          </Col>
        )}

      {witnessIdentification &&
        draftEntryUiHelper.getIdentificationViewCard(
          witnessIdentification,
          false,
          4
        )}
      {!!(witness && witness.signature && witness?.signature?.data) && (
        <Col sm={12} md={4}>
          <Card className="h-md-100">
            <Card.Header>Signature</Card.Header>
            <Card.Body className="text-center">
              {draftEntryUiHelper.getSignatureViewImage(
                witness.signature.data,
                180,
                200
              )}
            </Card.Body>
          </Card>
        </Col>
      )}
    </Row>
  );
};

const getIdentificationViewCard = (identity, removeMethod, col, editMethod) => {
  // logger.log('getIdentificationViewCard', identity);
  return identity ? (
    <Col
      lg={col ? col : 4}
      className="mb-3"
      key={_.uniqueId('identification-view') + identity.GUID}
    >
      <Card className="h-md-100">
        <Card.Header className="pb-0">
          <Flex
            justifyContent="between"
            alignContent="center"
            alignItems="center"
            className="pb-2"
          >
            <Flex
              justifyContent="center"
              alignContent="center"
              alignItems="center"
            >
              <FontAwesomeIcon icon={faIdBadge} size="lg" className="me-3" />
              <h5 className="mb-0 mb-1">
                Identification
                <SoftBadge
                  pill
                  bg={
                    identity.id_type === enums.ID_TYPES.NONE
                      ? 'warning'
                      : 'success'
                  }
                  className="fs--2"
                >
                  {identity.id_type}
                </SoftBadge>
              </h5>
            </Flex>
            <Flex>
              {editMethod && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="mx-2 mt-1"
                  onClick={() => editMethod(identity)}
                >
                  <FontAwesomeIcon icon={faEdit} size="sm" />{' '}
                </Button>
              )}
              {removeMethod && (
                <Button
                  variant="outline-danger"
                  className="mx-2 mt-1"
                  size="sm"
                  onClick={() => removeMethod(identity.identification_id)}
                >
                  <FontAwesomeIcon icon={faTrash} size="sm" />{' '}
                </Button>
              )}
            </Flex>
          </Flex>
          <hr className="my-0" />
        </Card.Header>

        <Card.Body as={Flex} justifyContent="between" className="pt-1">
          <div className="fs--1">
            <p className="mb-1">
              <span className="fw-semi-bold">Name:</span>{' '}
              {identity?.prefix && identity?.prefix + ' '}
              {identity.id_first_name
                ? identity?.id_first_name
                : identity?.first_name
                ? identity?.first_name
                : ''}{' '}
              {identity?.id_middle_name
                ? identity?.id_middle_name
                : identity?.middle_name
                ? identity?.middle_name + ' '
                : ''}
              {identity?.id_last_name
                ? identity?.id_last_name
                : identity?.last_name
                ? identity?.last_name + ' '
                : ''}
              {identity?.prefix && identity?.suffix}
            </p>
            {identity.id_number && (
              <p className="mb-1">
                <span className="fw-semi-bold">Id Number:</span>{' '}
                {/* {identity.id_number} */}
                {(identity?.id_number && identity?.province?.length > 0
                  ? `${identity?.province} `
                  : ``) +
                  (identity.id_number?.length > 0
                    ? `${identity.id_number}`
                    : 'N/A')}
              </p>
            )}
            {identity.id_issued_date && (
              <p className="mb-1">
                <span className="fw-semi-bold">Issue Date:</span>{' '}
                {/* {draftEntryUiHelper
                  .getDateTimeWithTimeZone(identity.id_issued_date)
                  .format('MM/DD/YYYY')} */}
                {identity.id_issued_date &&
                  moment(identity.id_issued_date).format('MM/DD/YYYY')}
              </p>
            )}
            {identity.id_expiration_date && (
              <p className="mb-1">
                <span className="fw-semi-bold">Expiration Date:</span>{' '}
                {/* {draftEntryUiHelper
                  .getDateTimeWithTimeZone(identity.id_expiration_date)

                  .format('MM/DD/YYYY')} */}
                {identity.id_expiration_date &&
                  moment(identity.id_expiration_date).format('MM/DD/YYYY')}
              </p>
            )}
            {identity.date_of_birth && (
              <p className="mb-1">
                <span className="fw-semi-bold">Date of Birth:</span>{' '}
                {/* {draftEntryUiHelper
                  .getDateTimeWithTimeZone(identity.date_of_birth)
                  .format('MM/DD/YYYY')} */}
                {identity.date_of_birth &&
                  moment(identity.date_of_birth).format('MM/DD/YYYY')}
              </p>
            )}
            <p className="mb-1">
              <span className="fw-semi-bold">Address:</span>{' '}
              {getIdentityAddress(identity) || 'N/A'}
            </p>
            {identity.notes && (
              <p className="mb-1">
                <span className="fw-semi-bold">Notes:</span>{' '}
                <i className="fs--1">{identity.notes}</i>
              </p>
            )}
          </div>
          <div></div>
        </Card.Body>
      </Card>
    </Col>
  ) : (
    <></>
  );
};

const getIdentityAddress = entry => {
  //logger.log("entry", entry);
  return entry ? (
    <>
      {entry.id_address_1 && entry.id_address_1.length > 0
        ? entry.id_address_1 + ' '
        : ''}{' '}
      {entry.id_address_2 && entry.id_address_2.length > 0
        ? entry.id_address_2 + ' '
        : ''}
      {entry.id_city && entry.id_city.length > 0 ? entry.id_city + ', ' : ''}
      {entry.id_state && entry.id_state.length > 0 ? entry.id_state + ', ' : ''}
      {entry.id_postal_code && entry.id_postal_code.length > 0
        ? entry.id_postal_code
        : ''}
    </>
  ) : (
    <></>
  );
};

const grabIconFromString = string => {
  string = string.toLowerCase();
  let icon = faPaperPlane;
  let activity = 'Activity';
  if (string.indexOf('document') >= 0) {
    icon = faFolder;
    activity = 'Document';
  } else if (string.indexOf('timezone') >= 0) {
    icon = faGlobeAmericas;
    activity = 'Timezone';
  } else if (string.indexOf('profile') >= 0) {
    icon = faGavel;
    activity = 'Notary commission';
  } else if (string.indexOf('signing package') >= 0) {
    icon = faFolderOpen;
    activity = 'Signing Package';
  } else if (string.indexOf('date & time') >= 0) {
    icon = faClock;
    activity = 'Notarization Date Time';
  } else if (string.indexOf('created') >= 0) {
    icon = faCalendarAlt;
    activity = 'Started';
  } else if (string.indexOf('fingerprint') >= 0) {
    icon = faWeight;
    activity = 'FingerPrint';
  } else if (string.indexOf('location') >= 0) {
    icon = faLocationArrow;
    activity = 'Location';
  } else if (string.indexOf('signature') >= 0) {
    icon = faSignature;
    activity = 'Signature';
  } else if (string.indexOf('signer') >= 0) {
    icon = faUser;
    activity = 'Signer';
  } else if (string.indexOf('notarization type') >= 0) {
    icon = faGavel;
    activity = 'Notarization Type';
  }
  return { icon: icon, activity: activity };
};

const parseAuditLogToTimeline = log => {
  let tileLineLog = [];
  if (log.length > 0) {
    _.map(log, l => {
      let a = draftEntryUiHelper.grabIconFromString(l.description);
      let item = {
        year: draftEntryUiHelper
          .getDateTimeWithTimeZone(l.timestamp)
          .format('MM/DD/YYYY'),
        date: draftEntryUiHelper
          .getDateTimeWithTimeZone(l.timestamp)
          .format('ddd hh:mm:ss A'),
        title: a.activity,
        description: l.description,
        icon: a.icon
      };
      tileLineLog.push(item);
    });
  }
  return tileLineLog;
};

const getDisplayAddress = address => {
  let { address_1, address_2, city, state, zip } = address;

  let hasAddressField = !!(
    (address_1 && address_1.length > 0) ||
    (address_2 && address_2.length > 0)
  );
  let hasAreaField = !!(
    (city && city.length > 0) ||
    (state && state.length > 0) ||
    (zip && zip.length > 0)
  );

  let result = '';
  if (hasAddressField) {
    result =
      (address_1 && address_1.length > 0 ? address_1 + ' ' : '') +
      (address_2 && address_2.length > 0 ? address_2 + ' ' : '');
  }
  if (hasAreaField) {
    result += city && city.length > 0 ? city + ', ' : '';
    result += state && state.length > 0 ? state + ', ' : '';
    result += zip && zip.length > 0 ? zip : '';
  }

  return _.trim(result, ' ,');
};

const getDateTimeWithTimeZone = (time, timezone) => {
  let LocalTimezone = store?.getState()?.app.userMaster?.LocalTimezone;
  timezone =
    userHelper.getTimezoneObj(timezone)?.zone ||
    userHelper.getTimezoneObj(LocalTimezone)?.zone ||
    moment?.tz?.MomentTimezone?.name;
  time = time || moment();
  return moment.tz(time, timezone);
};

const draftEntryUiHelper = {
  getSignatureViewImage,
  getFingerprintViewImage,
  getSignatureViewCards,
  getWitnessAddressViewCards,
  getIdentificationViewCard,
  getIdentityAddress,
  getWitnessViewCard,
  parseAuditLogToTimeline,
  grabIconFromString,
  getDisplayAddress,
  getDateTimeWithTimeZone
};

export default draftEntryUiHelper;
